import { Link } from "react-router-dom";
import { Globe, Heart, Zap, Shield } from "lucide-react";

const About = () => (
  <div className="pt-16 md:pt-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--tt-accent)] font-semibold">
            About Turbo Transit
          </div>
          <h1 className="font-display text-5xl md:text-6xl font-bold text-[var(--tt-navy)] mt-4 leading-[0.98]">
            Connecting people <br />and packages <br />— globally.
          </h1>
          <p className="mt-6 text-lg text-[var(--tt-ink-soft)] leading-relaxed">
            Turbo Transit is a global shipping and logistics provider that
            simplifies the way people send packages across borders. Whether
            you&apos;re a business needing bulk freight or an individual sending
            a single gift, we connect senders and recipients across 180+
            countries with real-time tracking, competitive rates, and a deep
            commitment to care for every box that leaves our warehouse.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/quote" className="btn-primary">Get a quote</Link>
            <Link to="/services" className="btn-ghost">See services</Link>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {[
            { icon: Globe, title: "Global reach", body: "180+ countries served from our Troy, Michigan hub." },
            { icon: Zap, title: "Truly fast", body: "Turbo Air Express delivers in 7 days door-to-door." },
            { icon: Shield, title: "Insured", body: "Coverage up to $2,500 per shipment. Liquid & hazmat policies disclosed." },
            { icon: Heart, title: "People first", body: "Real humans you can call. We care about every box." },
          ].map((p, i) => {
            const I = p.icon;
            return (
              <div key={i} className="card p-6">
                <I className="h-6 w-6 text-[var(--tt-accent)]" />
                <h3 className="font-display text-xl font-bold text-[var(--tt-navy)] mt-4">{p.title}</h3>
                <p className="mt-2 text-sm text-[var(--tt-ink-soft)] leading-relaxed">{p.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </div>
);

export default About;
